// extracted by mini-css-extract-plugin
export default {"row":"List_row__Oo52q","column":"List_column__FHBEo"};